export { AdminShell, type AdminTab } from '@/features/admin/components/admin-shell'
export type {
  AdminUserSummary,
  ResetPasswordResult,
  DeactivateStaffResult,
  UserAuditLogEntry,
  LastSyncRun,
} from '@/features/admin/api/admin-users.api'
export type {
  AdminOverview,
  AdminOverviewParams,
  AdminRecentCase,
} from '@/features/admin/api/admin-overview.api'
export {
  useAdminUsers,
  useResetStaffPassword,
  useDeactivateStaff,
} from '@/features/admin/hooks/use-admin-users'
export { useAdminOverview } from '@/features/admin/hooks/use-admin-overview'
export { AdminOverviewView } from '@/features/admin/components/admin-overview-view'
export { AdminCasesView } from '@/features/admin/components/admin-cases-view'
export { AdminInvestorsView } from '@/features/admin/components/admin-investors-view'
export { AdminStaffView } from '@/features/admin/components/admin-staff-view'
export { AdminCallsView } from '@/features/admin/components/admin-calls-view'
export { AdminClientDetailView } from '@/features/admin/components/admin-client-detail-view'
export { AdminProfileView } from '@/features/admin/components/admin-profile-view'
export { AdminClientDashboardPreviewView } from '@/features/admin/components/admin-client-dashboard-preview-view'
export { AdminClientPrescriptionPreviewView } from '@/features/admin/components/admin-client-prescription-preview-view'
